export const ACTIONS = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  CREATE: 'CREATE',
  MANAGE: 'MANAGE',
  UPGRADE: 'UPGRADE'
}

export const SUBJECTS = {
  VENDORS: 'VENDORS',
  MY_VENDORS: 'MY_VENDORS',
  VENDORS_REPOSITORY: 'VENDORS_REPOSITORY',
  VENDOR_DETAILS: 'VENDOR_DETAILS',
  VENDOR_USERS: 'VENDOR_USERS',
  VENDOR_PERMISSION: 'VENDOR_PERMISSION'
}
